var HTTP_RESOURCE_PATTERN = /^http:\/\//;

function isHttpResource(uri) {
  return HTTP_RESOURCE_PATTERN.test(uri);
}

module.exports = isHttpResource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/is-http-resource.js
// module id = 721
// module chunks = 0 1